import React, { useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import type { DebounceSettings } from 'lodash';

const DEFAULT_DEBOUNCE_OPTIONS: DebounceSettings = { leading: true };

type DebouncedFunction = (...args: any[]) => any;
type SetStateFunction<S> = React.Dispatch<React.SetStateAction<S>>;

function useDebounced<T extends DebouncedFunction>(
  func: T,
  wait: number,
  options = DEFAULT_DEBOUNCE_OPTIONS
) {
  return useMemo(() => debounce(func, wait, options), [func, wait, options]);
}

export default function useDebouncedState<S>(
  initialState: S,
  wait,
  options?
): [S, SetStateFunction<S>] {
  const [state, setState] = useState<S>(initialState);
  const debouncedSetState = useDebounced(setState, wait, options);
  return [state, debouncedSetState];
}
